const al = {
  //main screen
  quiz_title: 'Mirë se erdhe në #play4sdgs!',
  quiz_sdg_info_label: 'Mëso rreth SDGs',
  quiz_main_button: 'Fillo lojën',
  quiz_info_title: 'Rregullat e lojës',
  quiz_info_subheader_1: 'Mëso si të luash:',
  quiz_info_content_1: 'Qëllimi i kësaj loje është që sa më shumë pyetjeve t’i përgjigjeni aq më shumë të mësoni rreth Objektivave të Zhvillimit të Qëndrueshem nga United Nations.\n\nJu mund të luani sa herë të dëshironi, përzgjidhni quiz-in dhe sfidoni njohuritë.Në fund nëse përgjigjesh saktë përfiton dhurata!',
  quiz_info_subheader_2: 'Si të fitoni?',
  quiz_info_content_2: 'Për të fituar duhet të kaloni quiz-in me 90% përgjigje të sakta brënda afatit kohor. Për çdo pyetje keni në dispozicion 30 sekonda kohë për t’u përgjigjur.',
  quiz_info_subheader_3: 'Çfarë fitoni?',
  quiz_info_content_3: 'Për lojën e parë ju fitoni 500mb, ky bonus merret vetëm një herë në DITE.\nPër lojën e dytë ju fitoni 1GB, ky bonus merret vetëm një herë në JAVE.\nPër lojën e parë ju fitoni dhurata nga United Narions, ky bonus merret vetëm një herë në MUAJ.',
  quiz_info_subheader_4: 'Kush mund të luajë?',
  quiz_info_content_4: 'Të gjithë mund të luajnë.',
  quiz_info_subheader_5: 'Çfarë janë Objektivat e Zhvillimit të Vazhdueshem dhe ku mund të mësoj më tepër rreth kësaj teme?',
  quiz_info_content_5: 'Mund të zhvilloni njohuritë tuaja duke klikuar',
  quiz_info_content_6: ' këtu.',
  quiz_level_selection_title: 'Le të luajmë!',
  quiz_level_selection_subtitle: 'Zgjidh quiz që do të luash...',

  quiz_first_level_description: 'Luaj dhe fito cdo ditë, bonusi merret vetëm ',
  quiz_first_level_description_bold: 'një herë në ditë',
  quiz_second_level_description_bold: 'një herë në javë',
  quiz_third_level_description_bold: 'një herë në muaj',

  quiz_game_number_slide: 'Quiz %1$s',
  quiz_game_question_number: 'Pyetja %1$s/%2$s',
  quiz_game_collected_points: 'Pikë të mbledhura: ',
  quiz_game_timer: 'Koha e mbetur 0:%1$s',
  quiz_game_confirm_button: 'Konfirmo',
  quiz_game_continue_button: 'Vazhdo',
  quiz_game_play_again_button: 'Luaj sërish',
  quiz_game_correct_question: 'Përgjigje e saktë!',
  quiz_game_wrong_question: 'Përgjigje e gabuar!',
  quiz_game_oot_question: 'Koha mbaroi!',
  quiz_game_finished: 'Quiz Mbaroi!',
  quiz_game_error: 'Dicka shkoi gabim!',

}

export default al
